import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form/dynamic-form.component';
import { FormFieldConfig } from '../dynamic-form/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-approval-flow-test',
  standalone: true,
  imports: [CommonModule, DynamicFormComponent],
  template: `
    <div class="container">
      <h2>簽核流程預載入測試</h2>
      <p>這個測試頁面展示了表單開啟時自動解析並預載入簽核流程的功能。</p>
      
      <app-dynamic-form
        [formName]="testFormName"
        [config]="testFormConfig"
        [preview]="true"
        [assistantid]="'test'"
        [assistantname]="'測試助手'">
      </app-dynamic-form>
    </div>
  `,
  styles: [`
    .container {
      max-width: 800px;
      margin: 20px auto;
      padding: 20px;
    }
    
    h2 {
      color: #333;
      margin-bottom: 10px;
    }
    
    p {
      color: #666;
      margin-bottom: 20px;
    }
  `]
})
export class ApprovalFlowTestComponent {
  testFormName = 'safety_report_test';
  
  testFormConfig: FormFieldConfig[] = [
    {
      type: 'paragraph',
      label: '測試說明',
      id: 'test_intro',
      name: 'test_intro',
      content: '這是一個測試表單，用於驗證簽核流程的自動解析和預載入功能。',
      textAlign: 'left'
    },
    {
      type: 'text-input',
      label: '事故描述',
      id: 'incident_description',
      name: 'incident_description',
      placeholder: '請描述事故的基本情況',
      required: true
    },
    {
      type: 'approval-flow',
      label: '簽核流程',
      id: 'approval_flow_1',
      name: 'approval_flow_1',
      placeholder: '系統將自動載入適用的簽核流程',
      required: false
    }
  ];
}